// Haftara title lookup for a parasha, by tradition (nusach).
// Used by UserPortalPage, ParashaOverviewPage and ChooseReadingsPage.

import haftarotData from '../../data/haftarot.json';

export function getHaftaraTitle(
  parashaEnglish: string,
  traditionKey: string | null,
): string | null {
  const nusach = traditionKey === 'ashkenaz' ? 'ashkenaz' : 'sfarad';
  const entry = (
    haftarotData as Array<{ nusach: string; parsha: string; haftaraTitle?: string }>
  ).find((h) => h.nusach === nusach && h.parsha === parashaEnglish);
  return entry?.haftaraTitle ?? null;
}
